import { Box, Divider, Typography } from '@atgfr8/atg-ui-tailwind';
import { Notification } from '@components';

type HeaderProps = {
  title: string;
  subTitle?: string;
};

const CustomerHeader = (props: HeaderProps) => {
  return (
    <Box class="mb-[10px]!">
      <Typography class="text-xl! font-medium!">{props.title}</Typography>
      <Divider class="mb-[10px]!" />
      {Boolean(props.subTitle) && (
        <Notification type="info" text={props.subTitle} sxProps="w-fit!" />
      )}
    </Box>
  );
};

export default CustomerHeader;
